import { AssessmentService } from '$synapse/services';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';

@Component({
  selector: 'syn-assessment-lesson-import',
  templateUrl: './lesson-import.component.html',
  styleUrls: ['./lesson-import.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class LessonImportComponent {
  private readonly _assessmentService = inject(AssessmentService);
  private readonly _modalDisplay =
    inject<MatDialogRef<LessonImportComponent>>(MatDialogRef);
  private readonly _router = inject(Router);
  data = inject(MAT_DIALOG_DATA);

  assessmentPdfLessonFile: FileList = null;
  isSubmitOk = false;
  assessmentId: string;

  constructor() {
    const data = this.data;

    this.assessmentId = data.assessmentId;
  }

  pdfLessonFileBrowseHandler(files: FileList) {
    this.assessmentPdfLessonFile = files;
    this._submitCheck();
  }

  submit() {
    if (!this.isSubmitOk) {
      return;
    }
    this._upload();
    this._modalDisplay.close();
  }

  private _submitCheck() {
    if (!this.assessmentPdfLessonFile) {
      return (this.isSubmitOk = false);
    }
    this.isSubmitOk = true;
  }

  private _upload() {
    this._assessmentService
      .uploadAssessmentLesson(this.assessmentId, this.assessmentPdfLessonFile)
      .subscribe((isSuccess) => {
        if (isSuccess) {
          this._router.navigate(['/questionnaires'], {
            queryParamsHandling: 'merge',
          });
        }
      });
  }
}
